const fileCategory = () => import('@/pages/file/category/index.vue');

export default [{
    path: '/file/category',
    component: fileCategory,
    meta: [{
        name: '文件管理',
		activeRoute: '/file/manage'
    },
    {
        name: '文件分类',
        activeRoute: '/file/category'
    }]
}];